import { Flex, Icon, Stack, Text, useToast } from '@pairy/pds-react';
import copy from 'copy-to-clipboard';

import * as Styled from './index.styles';

interface Props {
  email: string;
  link: string;
  handleLinkDelete: () => void;
}

const OneToOneLinkItem = ({ email, link, handleLinkDelete }: Props) => {
  const toast = useToast();

  const handleLinkCopy = () => {
    copy(link);
    toast('링크가 복사되었습니다');
  };

  return (
    <Styled.Container width="100%" gap={16} padding={16} direction="column">
      <Flex justifyContent="space-between" alignItems="flex-start">
        <Stack gap={4} direction="column">
          <Text variant="sm-medium" color="zinc_400">
            이메일
          </Text>
          <Text variant="md-medium">{email}</Text>
        </Stack>
        <Styled.LinkDeleteButton
          variant="cerise_100"
          paddingX={8}
          paddingY={4}
          radius={4}
          leftIcon={<Icon icon="ph:trash" color="inherit" size={17} />}
          onClick={handleLinkDelete}
        >
          숨김
        </Styled.LinkDeleteButton>
      </Flex>

      <Stack gap={4} direction="column">
        <Text variant="sm-medium" color="zinc_400">
          공유링크
        </Text>
        <Styled.LinkBlueWrapper alignItems="center" onClick={handleLinkCopy}>
          <Styled.LinkWrapper variant="sm-medium" color="skyblue_600">
            {link}
          </Styled.LinkWrapper>

          <Styled.CopyButtonWrapper>
            <Icon icon="ph:copy" size={17} color="inherit" />
            <Text variant="sm-medium" color="inherit">
              복사하기
            </Text>
          </Styled.CopyButtonWrapper>
        </Styled.LinkBlueWrapper>
      </Stack>
    </Styled.Container>
  );
};

export default OneToOneLinkItem;
